
// import { M_ITEMS } from '../models/M_ITEMS';

export class M_SIPARIS_DETAY {

     
        ID:number; 
        
       ItemsRef:number;

        StokKartID:number;

       IslemTuru:number;

       FaturaID:number;

        SatirNo:number;

        CariKartID:number;

        DepoKodu:number;

        Miktar:number;

        BirimFiyat:number;

       IskontoOran1:number;

        IskontoOran2:number;

       IskontoOran3:number;

       IskontoTutar:number;

        IskontoluBirimFiyati:number;

        AraTutar:number;

       Kdv:number;
        Tutar:number;

        KdvOran:number;

       SlsMan:string;

       Sign:number;

        SaticiRef:number;

        Maliyet:number;

       NetFiyat:number;
       
        siparisID:number;
        UrunName:string;
        SIPARIS_DURUM_ID:number;
        VadeGun:number;
        ACIK1:string;
        ACIK2:string;
        ACIK3:string;
        ACIK4:string;
        ACIK5:string;
        ACIK6:string;
       // @ManyToMany(type => M_ITEMS, a => a.LOGICALREF)
       // @JoinTable()
       // FK_ITEM: M_ITEMS

}



// WEBPACK FOOTER //
// ./src/models/M_SIPARIS_DETAY.ts